import { FeedItems } from "@components/Tags/TagNonprofitsTab";
import { NextPage } from "next";

import { TagPage } from "src/pages/Tags/Tags";
import { getCauseInitialProps } from "src/utilities/ssr/getCauseInitialProps";

const CausePageExport: NextPage<{
  tagName: string;
  feedItems?: FeedItems;
}> = ({ tagName, feedItems }) => {
  return <TagPage tagName={tagName} initialFeedItems={feedItems} />;
};

CausePageExport.getInitialProps = getCauseInitialProps;

export default CausePageExport;
